import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  bigCard: {
    width: 124,
    height: 124,
    backgroundColor: '#ffffff',
    padding: '25px 0px',
    textAlign: 'center',
    fontFamily: "'Poppins', sans-serif",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  number: {
    color: '#2A3652',
    fontSize: 50,
    fontWeight: '1000',
    lineHeight: '34px',
  },
  text: {
    color: '#949494',
    fontSize: 15,
  },
  good: {
    color: '#4EAB96',
  },
  bad: {
    color: '#DB5163',
  },
}

const BigCard = ({ classes, value, text, good, bad }) => {
  return (
    <div className={classes.bigCard}>
      <div
        className={classNames({
          [classes.number]: true,
          [classes.good]: good,
          [classes.bad]: bad,
        })}
        style={{
          fontSize: calculateFontSize(value),
        }}
        title={value}
      >
        {truncateText(value)}
      </div>
      <div className={classes.text}>{text}</div>
    </div>
  )
}

/**
 * Calculates the font size of the big card
 * @param {string} value
 * @returns {number}
 */
const calculateFontSize = function(value) {
  switch (value.length) {
    case 0:
    case 1:
      return 34
    case 2:
      return 31
    case 3:
      return 28
    case 4:
      return 24
    case 5:
      return 21
    case 6:
      return 17
    case 7:
    default:
      return 14
  }
}

/**
 * Truncates the text so its not to long to display in the box.
 */
const truncateText = function(text) {
  if (text.length > 9) return text.slice(0, 9) + '...'
  return text
}

export default injectStyles(styles)(BigCard)



// WEBPACK FOOTER //
// ./src/Components/Stats/BigCard/index.js